import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateJobTitlePayload,
  JobTitleDto,
  UpdateJobTitlePayload,
} from '@/types/jobTitle';
import type { ListFilterPayload } from '@/types/filters';

interface GetJobTitlesParams {
  page?: number;
  size?: number;
  sort?: string;
}

// ============================================
// Job Titles CRUD — /platform-service/v1/job-titles
//
// `filters.departmentIds` is supported on /list — scopes results to job titles
// associated with any of the supplied department UUIDs. Accepted shapes per
// backend: string UUID, JSON array of strings, or `{ "in": [...] }`.
// ============================================

export const getJobTitles = async (
  params: GetJobTitlesParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<JobTitleDto>> => {
  const response = await api.post<PaginatedResponse<JobTitleDto>>(
    '/platform-service/v1/job-titles/list',
    body ?? {},
    { params },
  );
  return response.data;
};

export const getJobTitleById = async (id: string): Promise<JobTitleDto> => {
  const response = await api.get<JobTitleDto>(`/platform-service/v1/job-titles/${id}`);
  return response.data;
};

export const createJobTitle = async (
  data: CreateJobTitlePayload,
): Promise<JobTitleDto> => {
  const response = await api.post<JobTitleDto>('/platform-service/v1/job-titles', data, {
    successToast: true,
  });
  return response.data;
};

export const updateJobTitle = async (
  id: string,
  data: UpdateJobTitlePayload,
): Promise<JobTitleDto> => {
  const response = await api.put<JobTitleDto>(
    `/platform-service/v1/job-titles/${id}`,
    data,
    { successToast: true },
  );
  return response.data;
};

export const deleteJobTitle = async (id: string): Promise<void> => {
  await api.delete(`/platform-service/v1/job-titles/${id}`, { successToast: true });
};
